import Axios from '@/api/http'
import { Fetch } from '@/api/fetch'

/**
 * 获取明细组件中页签点击应用的数据
 * */
export function openapiGetcustomdata(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcustomdata',
    data: query
  })
}
/**
 * 获取无权限应用
 * */
export function getcusapper(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcusapper',
    data: query
  })
}

export function getuserdesks(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserdesks',
    data: query
  })
}

export function getuserspacedesks(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserspacedesks',
    data: query
  })
}
export function getuserroles(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserroles',
    data: query
  })
}

export function getuserspaceroles(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserspaceroles',
    data: query
  })
}
export function refreshaccesstoken(query) {
  return Axios({
    method: 'post',
    url: '/api/refreshaccesstoken',
    data: query
  })
}
export function ixmlogout(query) {
  return Axios({
    method: 'post',
    url: '/api/ixmlogout',
    data: query
  })
}

/**
 * 官网获取明细组件中页签点击应用的数据
 * */
export function outGetcustomdata(query) {
  return Axios({
    method: 'post',
    url: '/out/getcustomdata',
    data: query
  })
}
/**
 * 获取列表是否未填
 * */
export function getapprovalcyclelist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovalcyclelist',
    data: query
  })
}

/**
 * 获取自定义状态文字
 * */
export function getdefinedstatus(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getdefinedstatus',
    data: query
  })
}

/**
 * 获取明细组件的红点以及新增权限
 * */
export function openapiGetcustomappstatus(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcustomappstatus',
    data: query
  })
}

/**
 * 点击未读数据状态的时候修改数据读取状态为已读
 * */
export function openapiUpdateisread(query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateisread',
    data: query
  })
}

/**
 * 配置应用、仪表盘、工坊点击是否有进入权限查询
 * */
export function getappperAuthority(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getappper',
    data: query
  })
}
/**
 * 对应管理员自己的组织
 * */
export function getdeptlist(query) {
  return Axios({
    method: 'post',
    url: '/api/getdeptlist',
    data: query
  })
}

/**
 * 对应管理员自己及其下级的组织
 * */

export function getdeptalllist(query) {
  return Axios({
    method: 'post',
    url: '/api/getdeptalllist',
    data: query
  })
}


/**
 * 获取自己的空间
 */
export function getuserspaces(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserspaces',
    data: query
  })
}

/**
 * 获取空间组件的列表
 */
export function getorganizationlist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getorganizationlist',
    data: query
  })
}
/**
 * 获取个人空间组件的列表
 */
export function getupacelistbytype(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getupacelistbytype',
    data: query
  })
}
/**
 * 外网获取空间id
 */
export function dentryspacemsg(query) {
  return Axios({
    method: 'post',
    url: '/out/dentryspacemsg',
    data: query
  })
}

/**
 * 获取开放能力的列表
 */
export function getcompetencymanagelist(query) {
  return Axios({
    method: 'post',
    url: '/api/getcompetencymanagelist',
    data: query
  })
}

/**
 * 获取开放能力的列表
 */
export function getusertiporgs(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getusertiporgs',
    data: query
  })
}
/**
 * 获取外网门户配置信息
 */
export function getrolecustom(query) {
  return Axios({
    method: 'post',
    url: '/out/getopenschool',
    data: query
  })
}

/**
 * 获取用户是否有开启后台管理
 */
export function getcurrentusertip(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcurrentusertip',
    data: query
  })
}
/**
 * 获取用户是否有开启后台管理
 */
export function getoutcustomdeskkey(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getoutcustomdeskkey',
    data: query
  })
}
/**
 * 获取用户是否有开启后台管理
 */
export function getregisterusertemplate(query) {
  return Axios({
    method: 'post',
    url: '/out/getregisterusertemplate',
    data: query
  })
}
/**
 * 获取门户配置信息
 */
export function getcustomdesk(query, keyOne) {
  return Fetch({
    method: 'GET',
    url: '/openapi/getcustomdesk',
    params: query,
    keyOne
  })
}
/**
 * 获取门户配置信息
 */
export function getApicustomdesk(query, keyOne) {
  return Fetch({
    method: 'GET',
    url: '/api/getcustomdesk',
    params: query,
    keyOne
  })
}
/**
 * 获取默认门户配置信息
 */
export function getFetchcustomdesklist(query, keyOne) {
  return Fetch({
    method: 'GET',
    url: '/openapi/getcustomdesklist',
    params: query,
    keyOne
  })
}
/**
 * 获取默认门户配置信息
 */
export function getcustomdesklist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcustomdesklist',
    data: query
  })
}
/**
 * 判断是否有重新保存
 */
export function getcustomdeskkey(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcustomdeskkey',
    data: query,
  })
}

/**
 * 判断是否有重新保存
 */
export function getapppermission(query) {
  return Axios({
    method: 'post',
    url: '/api/getapppermission',
    data: query,
  })
}
/**
 * 判断是否有权限显示
 */
export function getinherit(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getinherit',
    data: query,
  })
}
/**
 * 获取当前用户组织
 */
export function getuserorgs(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserorgs ',
    data: query,
  })
}

export function getapprovingbyid(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovingbyid ',
    data: query,
  })
}

export function validurldddress(query) {
  return Axios({
    method: 'post',
    url: '/out/validurldddress',
    data: query,
  })
}


export function importimageandattachment(query) {
  return Axios({
    method: 'post',
    url: '/openapi/importimageandattachment',
    data: query,
  })
}

export function datasyncform(query) {
  return Axios({
    method: 'post',
    url: 'openapi/datasyncform',
    data: query,
  })
}

export function getapprovinglist(query) {
  return Axios({
    method: 'post',
    url: 'api/getapprovinglist',
    data: query,
  })
}

export function issuescandevicetask(query) {
  return Axios({
    method: 'post',
    url: 'openapi/issuescandevicetask',
    data: query,
  })
}

export function getscandevicetaskstatus(query) {
  return Axios({
    method: 'post',
    url: 'openapi/getscandevicetaskstatus',
    data: query,
  })
}
export function getscanfile(query) {
  return Axios({
    method: 'post',
    url: 'openapi/getscanfile',
    data: query,
  })
}
export function confirmscanattachmentupload(query) {
  return Axios({
    method: 'post',
    url: 'openapi/confirmscanattachmentupload',
    data: query,
  })
}
export function cancelscanattachmentupload(query) {
  return Axios({
    method: 'post',
    url: 'openapi/cancelscanattachmentupload',
    data: query,
  })
}
